import * as React from 'react';

export const Refresh = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M1.15 2.872v3.734h3.733M14.839 12.828V9.094h-3.733" />
      <path d="M13.277 5.983a5.6 5.6 0 0 0-9.24-2.09L1.15 6.606m13.689 2.488l-2.887 2.713a5.6 5.6 0 0 1-9.24-2.09" />
    </g>
  </svg>
);
